<template>
  <div id="appointment" class="m-auto mt-8 rounded w-full text-center">
    <vue-element-loading :active="show" spinner="ring" is-full-screen color="#38b2ac"/>
    <div class="bg-white m-auto max-w-2xl overflow-hidden rounded shadow-lg">
      <div class="px-6 py-4">
        <div class="bg-white m-auto max-w-sm overflow-hidden" v-html="details"
             v-if="disable=='hidden'"></div>
        <button
          class="appearance-none bg-blue-600 cursor-pointer h-22 hover:bg-blue-700 inline-block mt-10 mb-4 p-2 rounded text-2xl text-white w-10/12 focus:outline-none outline-none"
          @click="viewDetail" :class='disable'
        >
          {{ trans('view_details')  }}
        </button>
        <button
          class="appearance-none bg-blue-600 cursor-pointer h-22 hover:bg-blue-700 inline-block mb-4 p-2 rounded text-2xl text-white w-10/12 focus:outline-none outline-none"
          v-show="customerSettings.cancellationByPatientAllowed"
          @click="cancelAppointment" :class='disable'
        >
          {{ trans('cancel')  }}
        </button>

        <!--        ask for suggestions-->
        <button v-if="suggestions"
          class="appearance-none bg-blue-600 cursor-pointer h-22 hover:bg-blue-700 inline-block mb-10 p-2 rounded text-2xl text-white w-10/12 focus:outline-none outline-none"
          v-show="customerSettings.suggestionsByPatientAllowed"
          @click="suggestNewTimings"
          :class='disable'
        >
          {{ trans('suggest') }}
        </button>

      </div>
    </div>
    <transition name="fade">
      <div class="bg-white m-auto max-w-sm overflow-hidden rounded shadow-lg mt-8 p-2" v-html="details"
           v-if="showDetails"></div>
    </transition>
  </div>
</template>

<script>
  import Popup from '@/mixins/Popup'
  import {mapActions,mapGetters} from 'vuex'
  import VueElementLoading from 'vue-element-loading'

  export default {
    name: "Appointment",
    mixins: [Popup],
    components: {
      VueElementLoading,
    },
    data() {
      return {
        showDetails: false,
        details: '',
        disable: 'hidden',
        show: false,
        suggestions: false,
        showSuggestions: false,
        appointmentCancelText: 'Appointment Cancelled.',
        cancelButton: 'Cancel Appointment.',
        viewDetailsButton: 'View Details.',
        confirmationBox: {
          title: null,
          text: null,
          confirmButtonText: null,
          cancelButtonText: null,
          
        },
        suggestButton: 'Suggest.',
        verbiageData: {},
        customerSettings: {
          cancellationByPatientAllowed: false,
          suggestionsByPatientAllowed: false
        }
      }
    },

   
    computed: {
      ...mapGetters('verbiage', {
        verbiage: 'verbiage'
      }),
    },
    methods: {
      ...mapActions('appointment', [
        'get',
        'cancel',
        'suggestTime'
      ]),
      ...mapActions({
        getVerbiage: 'verbiage/loadVerbiage',
      }),
      trans(key) {
        if ( this.verbiageData && this.verbiageData[key] ) {
          return this.verbiageData[key];
        } else {
          return key;
        }
      },
      loadDetails() {
        this.get({
          id: this.$route.params.id
        }).then(response => {
          this.details = response.data.template
          this.verbiageData = response.data.verbiage
          this.suggestions = response.data.suggestions
          console.log('response.data.customerseetting', response.data.customerSettings)
          if(response.data.customerSettings) {
            
            this.customerSettings = response.data.customerSettings
          }
          
          if (typeof response.status !== 'undefined' && response.status == 'fail') {
            this.disable = 'hidden'
          } else {
            this.disable = ''
          }
        }).catch(() => {
          //this.$router.push({name: 'NotFound'})
        })
      },
      viewDetail() {
        this.showDetails = !this.showDetails
        if (!this.showDetails) {
          this.viewDetailsButton = this.viewDetailsText
        } else {
          this.viewDetailsButton = this.hideDetailsText
        }
      },
      cancelAppointment() {
        this.$swal.fire({
          title: this.trans('are_you_sure'),
          text: this.trans('cannot_revert'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.trans('yes'),
          cancelButtonText: this.trans('no')
        }).then((result) => {
          if (result.value) {
            this.show = true
            this.cancel({
              id: this.$route.params.id,
              cancelled_by: 'client'
            }).then(() => {
              this.show = false
              this.popup(this.trans('appointment_cancelled'), 'success', 5000)
              this.disable = 'hidden'
              this.details = this.trans('appointment_cancelled')
            }).catch(() => {
              this.show = false
            })
          }
        })
      },
      suggestNewTimings() {
        this.$router.push('/appointment/' + this.$route.params.id + '/suggestions')
      },
    },
    mounted(){
      this.loadDetails();

      let locale = null
      let host = window.location.host
      if(host.indexOf('user') >= 0 || host.indexOf('localhost') >= 0) {
        locale = 'se'
      }else if(host.indexOf('english') >= 0) {
        locale = 'en'
      } else if(host.indexOf('svenska') >= 0) {
        locale = 'se'
      }
      
      this.getVerbiage({
        languageCode: locale || 'se'
      })


    }
  }
</script>

<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }

  header {
    display: none !important;
  }

  header::before {
    display: none !important;
  }

  .h-22 {
    height: 84px;
  }

  .w-brief {
    width: 480px;
  }
</style>